import React from 'react'
import PropTypes from 'prop-types'

import { FOOTER_HEIGHT, HEADER_THEME, SPACING } from '../components/constants.js'
import Footer from '../components/Footer.jsx'
import Grid from '../components/Grid.jsx'
import Header from '../components/Header.jsx'
import Margin from '../components/Margin.jsx'
import Notes from '../components/Notes.jsx'
import Slide from '../components/Slide.jsx'

import useRect from '../hooks/useRect.js'

const Vertical = (props) => {
  const [HeaderRect, headerRect] = useRect()
  const [NotesRect, notesRect] = useRect()

  const { title, description, notes, page, content } = props

  return (
    <Slide>
      <Margin left={SPACING} top={SPACING} right={SPACING} bottom={SPACING + FOOTER_HEIGHT}>
        <Grid
          direction="vertical"
          gap={48}
          items={[
            {
              component: (
                <svg x={0} y={0} width={'100%'} height={'100%'}>
                  <Header
                    title={title}
                    description={description}
                    {...HEADER_THEME.VERTICAL}
                    DelegatedRect={HeaderRect}
                  />
                </svg>
              ),
              size: headerRect,
            },
            {
              component: (
                <Grid
                  direction="vertical"
                  gap={48}
                  items={
                    notes
                      ? [
                          {
                            component: content(),
                            size: 1,
                          },
                          {
                            component: (
                              <Notes content={notes} align="left" DelegatedRect={NotesRect} />
                            ),
                            size: notesRect,
                          },
                        ]
                      : [
                          {
                            component: content(),
                            size: 1,
                          },
                        ]
                  }
                />
              ),
              size: 1,
            },
          ]}
        />
      </Margin>
      <Footer page={page} theme={{ background: 'dark', icon: 'light', page: 'light' }} />
    </Slide>
  )
}

Vertical.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  notes: PropTypes.string,
  page: PropTypes.number,
  content: PropTypes.func.isRequired,
}

Vertical.defaultProps = {
  title: '',
  description: '',
  notes: '',
  page: 0,
}

export default Vertical
